<template>
<div :ref="LoadingObj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">运营分析详情</span>
        <div class="TTL-BTN-LIST">
        <wcbutton :option="{title:'返回运营分析',type:'del'}" class="left15" @finish="(val)=> {$parent.JUMPVIEW({name:'EsStatoperates'})}" />
        </div>
    </div>

    <!-- 总分析图 -->
    <div class="TTL-pie-lists top40">
        <div class="TTL-table">
            <span class="TTL-table-title">闲置、求购趋势图（{{opratedata.time}}）</span>
            <el-table :data="statAlldata" stripe="true" empty-text="" class="top30">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="goodsnums" label="数据发布" align="center"/>
                <el-table-column prop="salenums" label="发布闲置" align="center"/>
                <el-table-column prop="buynnums" label="发布求购" align="center"/>
            </el-table>
        </div>
        <div class="TTL-pie" :ref="statobj" />
    </div>    

    <!-- 个人趋势分析图 -->
    <div class="TTL-pie-lists top40">
        <div class="TTL-table">
            <span class="TTL-table-title">个人闲置、求购趋势图（{{opratedata.time}}）</span>
            <el-table :data="statpersondata" stripe="true" empty-text="" class="top30">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="person_nums" label="个人发布" align="center"/>
                <el-table-column prop="person_sale_nums" label="个人闲置" align="center"/>
                <el-table-column prop="person_buy_nums" label="个人求购" align="center"/>
            </el-table>
        </div>
        <div class="TTL-pie" :ref="statpersonobj" />
    </div>


    <!-- 企业趋势分析图 -->
    <div class="TTL-pie-lists top40">
        <div class="TTL-table">
            <span class="TTL-table-title">企业闲置、求购趋势图（{{opratedata.time}}）</span>
            <el-table :data="statcomponydata" stripe="true" empty-text="" class="top30">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="compony_nums" label="企业发布" align="center"/>
                <el-table-column prop="compony_sale_nums" label="企业闲置" align="center"/>
                <el-table-column prop="compony_buy_nums" label="企业求购" align="center"/>
            </el-table>
        </div>
        <div class="TTL-pie" :ref="statcomponyobj" />
    </div>


    <!-- 企业趋势分析图 -->
    <div class="TTL-pie-lists top40">
        <div class="TTL-table">
            <span class="TTL-table-title">新增会员趋势图（{{opratedata.time}}）</span>
            <el-table :data="statmemberdata" stripe="true" empty-text="" class="top30">
                <template v-slot:empty><el-empty description="暂无数据" /></template>
                <el-table-column prop="membernums" label="新增会员" align="center"/>
                <el-table-column prop="member_person_nums" label="个人会员" align="center"/>
                <el-table-column prop="member_compony_nums" label="企业会员" align="center"/>
            </el-table>
        </div>
        <div class="TTL-pie" :ref="statmemberobj" />
    </div>

            
</div>


</template>

<script>
import INTERFACE_MODEL_STAT from '@/Interface/Es/stat';
import * as echarts from 'echarts';

export default {
    components:{
        
    },
    data() {
        return {
            LoadingObj:'OperateDetail',  //loading对象   
            opratedata:'', //运营分析数据

            statobj:'statinfo',
            statAlldata:[],
            Statoption : {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '0',
                    left: 'center'
                },
                series: [
                    {
                    name: '数据发布量',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    padAngle: 5,
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        {value:11,name:'闲置发布'},
                        {value:11,name:'求购发布'}
                    ]
                    }
                ]
            },

            statpersonobj:'statpersoninfo',
            statpersondata:[],
            Statpersonoption : {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '0',
                    left: 'center'
                },
                series: [
                    {
                    name: '数据发布量',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    padAngle: 5,
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                    }
                ]
            },

            statcomponyobj:'statcomponyinfo',
            statcomponydata:[],
            Statcomponyoption : {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '0',
                    left: 'center'
                },
                series: [
                    {
                    name: '数据发布量',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    padAngle: 5,
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                    }
                ]
            },


            statmemberobj:'statmemberinfo',
            statmemberdata:[],
            Statmemberoption : {
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '0',
                    left: 'center'
                },
                series: [
                    {
                    name: '新增会员',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    avoidLabelOverlap: false,
                    padAngle: 5,
                    itemStyle: {
                        borderRadius: 10
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: []
                    }
                ]
            },


        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.opratedata=data.param;
                this.setGoodsUpdate(); //更新图形数据

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }else {
                this.opratedata=data.param;
                this.setGoodsUpdate(); //更新图形数据

            } 
        },


        /** 更新图形数据 **/
        setGoodsUpdate() {

            //设置总分析图信息
            //设置总分析图信息-设置table数据
            this.statAlldata=[];
            this.statAlldata.push({goodsnums:this.opratedata.goodsnums,salenums:this.opratedata.salenums,buynnums:this.opratedata.buynnums});
            //设置总分析图信息-设置饼状图数据
            this.Statoption.series[0].data=[];
            this.Statoption.series[0].data.push({value:this.opratedata.salenums,name:'发布闲置'});
            this.Statoption.series[0].data.push({value:this.opratedata.buynnums,name:'发布求购'});
            var chartDom = this.$refs[this.statobj];
            var myChart = echarts.init(chartDom);
            myChart.setOption(this.Statoption);


            //设置个人分析图信息
            //设置个人分析图信息-设置table数据
            this.statpersondata=[];
            this.statpersondata.push({person_nums:this.opratedata.person_nums,person_sale_nums:this.opratedata.person_sale_nums,person_buy_nums:this.opratedata.person_buy_nums});
            //设置个人分析图信息-设置饼状图数据
            this.Statpersonoption.series[0].data=[];
            this.Statpersonoption.series[0].data.push({value:this.opratedata.person_sale_nums,name:'个人闲置'});
            this.Statpersonoption.series[0].data.push({value:this.opratedata.person_buy_nums,name:'个人求购'});
            var chartDomPerson = this.$refs[this.statpersonobj];
            var personmyChart = echarts.init(chartDomPerson);
            personmyChart.setOption(this.Statpersonoption);


            //设置企业分析图信息
            //设置企业分析图信息-设置table数据
            this.statcomponydata=[];
            this.statcomponydata.push({compony_nums:this.opratedata.compony_nums,compony_sale_nums:this.opratedata.compony_sale_nums,compony_buy_nums:this.opratedata.compony_buy_nums});
            //设置企业分析图信息-设置饼状图数据
            this.Statcomponyoption.series[0].data=[];
            this.Statcomponyoption.series[0].data.push({value:this.opratedata.compony_sale_nums,name:'企业闲置'});
            this.Statcomponyoption.series[0].data.push({value:this.opratedata.compony_buy_nums,name:'企业求购'});
            var chartDomCompony = this.$refs[this.statcomponyobj];
            var componymyChart = echarts.init(chartDomCompony);
            componymyChart.setOption(this.Statcomponyoption);


            //设置会员分析图信息
            //设置会员分析图信息-设置table数据
            this.statmemberdata=[];
            this.statmemberdata.push({membernums:this.opratedata.membernums,member_person_nums:this.opratedata.member_person_nums,member_compony_nums:this.opratedata.member_compony_nums});
            //设置会员分析图信息-设置饼状图数据
            this.Statmemberoption.series[0].data=[];
            this.Statmemberoption.series[0].data.push({value:this.opratedata.member_person_nums,name:'个人会员'});
            this.Statmemberoption.series[0].data.push({value:this.opratedata.member_compony_nums,name:'企业会员'});
            var chartDommember = this.$refs[this.statmemberobj];
            var membermyChart = echarts.init(chartDommember);
            membermyChart.setOption(this.Statmemberoption);

        },


    },
}
</script>
<style scoped>
.TTL-pie-lists {display: inline-flex;width:50%;align-items: center;}
.TTL-table {display: inline-block;width:calc(50% - 20px);height: 180px;padding:10px;}
.TTL-pie {display: inline-block;padding:10px;width:calc(50% - 20px);height: 180px;}
.TTL-table-title {font-size:13px;color:#503b11;display: inline-block;width:100%;text-align: center;}
</style>